import React, {memo, useEffect, useRef, useState} from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import {Card, CardActions, Paper, Popper, Typography} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import {Button, Link} from "@mui/material";

const LargeTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#757575',
        color: '#f5f5f5',
        maxWidth: 'none',
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}));

// const LargeTooltip = ({className, title, children}) =>{
//     return <Tooltip title={<React.Fragment>
//         <h3>{title}</h3>
//     </React.Fragment>}
//                     className={`${className} `}
//                     sx={{
//                         bgcolor: '#f5f5f9',
//                         boxShadow: 1,
//                         maxWidth: 300,
//                         border: '1px solid #dadde9',
//                         color: '#f5f5f9',
//     }}
//
//     >
//         {children}</Tooltip>
// }

const ExtraTooltip = memo(function ExtraTooltip({
                                                    children,
                                                    width = "400px",
                                                    value,
                                                    link = null,
                                                    heading = null,
                                                    examples = null,
                                                    style = null,
                                                    className = null,
                                                }){

    const wrapper = useRef(null);
    const toolTipDiv = useRef(null);
    const toolTipValue = useRef(null);
    // const arrowElement = useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);
    // const [arrowElement, setArrowElement] = useState(null);
    const [showPopper, setShowPopper] = useState(false);

    const handleMouseEnter = () =>{
        if(toolTipValue.current){
            setShowPopper(true);
            setAnchorEl(toolTipValue.current);
        }
    }

    const handleMouseLeave = () =>{
        setShowPopper(false);
        setAnchorEl(null);
    }

    const learnMoreLink = <div className={"col-12 m-0 p-0"}>

        <p className={"m-0 p-0"} style={{color: "white"}}>
            <Link target="_blank"
                  rel="noopener"
                  // color="#dee2e6"
                  color="inherit"
                  variant={"h6"}
                  href={link}>
                Learn More
            </Link>
        </p>

    </div>

    return(
        <span  ref={wrapper}
              className={"m-0 p-0"}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{

              }}
        >
            <span ref={toolTipValue}
                 className="toolTipValue m-0 p-0"
            >
                {children}
            </span>
            {showPopper && (
                <Popper
                    open={anchorEl != null}
                    anchorEl={anchorEl}
                    style={{ width: width ? width : "250px",
                        zIndex: 1300,
                        // marginBottom: anchorEl.offsetHeight,
                        opacity: "0.9",}}
                    placement={"bottom"}
                >
                    <Card
                        className={"m-1 p-2 animated animation-duration-10 fadeIn"}
                        variant={"outlined"}
                        style={{
                            minHeight: wrapper.current.offsetHeight - 3,
                                 backgroundColor: "#4b4e4e",
                                 // opacity: "0.6",
                                 color: "whitesmoke",
                        }}
                    >
                        <CardContent className={"m-0"}>
                            {heading && <div className={"text-center"}>
                                <h4 style={{ color: "whitesmoke", marginBottom: ''}}>
                                    {heading}
                                </h4>
                            </div>}
                            {value && !examples &&
                                <div className={"m-0 p-0"}>
                                <p className={"m-0 p-0"}>
                                    {value}

                                </p>
                            </div>}
                            {examples &&
                            <div className={"row m-0 p-0"}>
                                {Array.isArray(examples) && examples.length > 0 &&
                                examples.map((example)=>(
                                    <>
                                        <div className={" col col-2 text-right d-inline my-0 mx-1 p-0"}>
                                            {example.icon}
                                        </div>&nbsp;
                                        {example.text && <div className={" col text-left d-inline m-0 p-0"}>
                                            {example.text}
                                        </div>}
                                    </>
                                ))}
                            </div>}


                            {/*<div ref={arrowElement} id={"arrowElement"} className={"joyride-arrow"} style={arrow}/>*/}
                        </CardContent>
                        {link && <CardActions className={"text-right m-0 p-0"}>
                            {learnMoreLink}
                        </CardActions>}
                    </Card>
                </Popper>
            )}

        </span>
    )
});
/**
 * BRCustomizedTooltip. description: standarized tooltip to be used in place of MUI tooltip or other optoins,
 * Tooltip can be plain, "large" (behaves like a regular tooltip but as an increased font size, or "extra", extra has two styles--
 * Explanation and Examples
 *
 * @param children
 * @param {string} title-- text for the tooltip (title was term used by MUI tooltip and also basic tooltips created using <span> html elements)
 * @param {boolean} large-- pass true for extra large font
 * @param {string} link-- valid href, can be external or internal page, opens in new window
 * @param {string} heading -- Heading for 'extra" tooltip
 * @param {array} examples-- [{icon: <example/>, text: "example"}, ...] an array of items that have the examples you'd liek to share, each object has an icon with it's individual styling and text to display next to it, can use one or the other or both
 * @param {string} width -- (optional) if width is not customized, it sets to 250px, usually needs to be about 400px for tooltips with examples
 * @returns {JSX.Element|*}
 *
 */
export const BRCustomizedTooltip = ({children,
                                        title= "",
                                        large=false,
                                        link=null,
                                        heading = "",
                                        examples= null,
                                        width=null,
                                        })=>{

    const [popoverOpen, setPopoverOpen] = useState(false)

    const handleClose = () =>{
        setPopoverOpen(false);
    }

    if((!title && !examples && !link)){
        return children
    }else if ( large && title && !(link || heading || examples)){
        return(
            <LargeTooltip title={<h3 className={`m-0 p-0`}
                                     style={{ color: '#f5f5f5', fontFamily: "'warnock-pro', sans-serif",}}>
                {title}
            </h3>
            }>
                {children}
            </LargeTooltip>
        )
    } else if (link || heading || examples){
        return(
            <ExtraTooltip value={title}
                          link={link}
                          examples={examples}
                          heading={heading}
                          width={width ? width : null}
            >
                {children}
            </ExtraTooltip>
        )
    }else{
        return(
            <Tooltip title={<p className={`m-0 p-0 `} style={{ fontSize: "1.25em",fontFamily: "'warnock-pro', sans-serif",}}>
                {title}
            </p>}>
                    {children}
            </Tooltip>
        )
    }


}

